import { create } from 'zustand';
import * as Sort from '@pkg/utils/sort';

/**
 * @param {Object[]} list
 * @returns {Object}
 */
export const storeProcesses = (list) => {
  const mapped = new Map();
  const l1 = new Map();
  const l2 = new Map();

  // Add uuid alias to each process and sort by name
  const processed = list
    .map((item) => ({ ...item, uuid: item.id }))
    .sort(Sort.alpha('name'));

  processed.forEach((process) => {
    const id = process.id;

    mapped.set(id, process);

    // L1 processes have no parent (level === 1 or no parent_id)
    if (!process.parent_id) {
      l1.set(id, process);
    } else {
      l2.set(id, process);
    }
  });

  return {
    list: processed,
    mapped,
    l1,
    l2,
  };
};

/**
 * @type {Function}
 * @param {Function} [getter]
 * @returns {any}
 */
const useStore = create((set) => ({
  list: [],
  mapped: new Map(),
  l1: new Map(),
  l2: new Map(),
  isLoading: true,
  setLoading: (isLoading) => set(() => ({ isLoading })),
  setProcesses: (list) => set(() => storeProcesses(list)),
}));

export default useStore;
